import React, { useState, useMemo } from 'react'

const ResumeCard = ({title,subTitle,result,des,compact}) => {
  const isCompact = compact || false;
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to truncate description to first 4 bullet points
  const truncateDescription = (description) => {
    if (!description) return '';
    
    // Split by </br> or <br> tags to count bullet points
    const bulletPoints = description.split(/<\/?br\s*\/?>/i).filter(point => point.trim());
    
    // If there are more than 4 bullet points, show only first 4
    if (bulletPoints.length > 4) {
      const truncatedPoints = bulletPoints.slice(0, 4);
      return truncatedPoints.map(point => point.trim()).join('</br>') + '</br>';
    }
    
    return description;
  };

  // Check if description needs truncation
  const needsTruncation = useMemo(() => {
    if (!des || isCompact) return false;
    const bulletPoints = des.split(/<\/?br\s*\/?>/i).filter(point => point.trim());
    return bulletPoints.length > 4;
  }, [des, isCompact]);

  const displayedDescription = useMemo(() => {
    if (!des || isCompact) return des;
    if (!needsTruncation || isExpanded) return des;
    return truncateDescription(des);
  }, [des, isCompact, needsTruncation, isExpanded]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  
  return (
    <div className={`w-full ${isCompact ? 'h-auto' : 'h-auto'} group flex`}>
      
      <div className={`${isCompact ? 'p-3 lgl:px-4 gap-2' : 'p-4 lgl:px-10 gap-6'} w-full bg-gradient-to-r from-[#000000] to-[#0a0a0a] hover:bg-gradient-to-b hover:from-[#000000] hover:to-[#000000] duration-300 rounded-lg flex flex-col justify-center shadow-shadowOne`}>
        <div className="flex flex-col lgl:flex-row justify-between gap-2 lgl:gap-0 lgl:items-center">
          <div>
            <h3 className={`${isCompact ? 'text-base' : 'text-xl md:text-2xl'} font-semibold group-hover:text-white duration-300`}>
              {title}
            </h3>
            <p className={`${isCompact ? 'text-xs mt-1' : 'text-sm mt-2'} text-gray-400 group-hover:text-white duration-300`}>
              {subTitle}
            </p>
          </div>
          <div>
          </div>
        </div>
        {result && (
          <p className={`${isCompact ? 'px-2 py-1 text-xs' : 'px-4 py-2 text-sm'} text-designColor bg-black bg-opacity-25 rounded-lg flex justify-center items-center shadow-shadowOne font-medium`}>
            {result}
          </p>
        )}
        {des && !isCompact && (
          <div className="pb-4">
            <p className="text-sm md:text-base text-justify text-gray-400 group-hover:text-gray-300 duration-300" dangerouslySetInnerHTML={{ __html: displayedDescription }}>
            </p>
            {needsTruncation && (
              <button
                onClick={toggleExpanded}
                className="mt-4 text-designColor hover:text-white duration-300 font-medium text-sm md:text-base flex items-center gap-1 cursor-pointer"
              >
                {isExpanded ? (
                  <>
                    <span>Show Less</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  </>
                ) : (
                  <>
                    <span>More Detail</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </>
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ResumeCard